import React, { useEffect } from 'react';
import Loading from 'src/components/Loading';
import { MobileConfigureIcon } from 'src/components/ui-icons/menu';
import { useAppDispatch, useAppSelector } from 'src/hooks/redux';
import { selectCurrentUser } from 'src/modules/users/selector';
import { FlexCol } from 'src/utils/flexLayouts';
import { getSettingsVPO } from '../store/settings/selectors';
import { fetchSettingsRequest } from '../store/settings/settings';
import { BACKEND_URL } from '../api/api';
import { resolveResourceUrl } from 'src/utils/url.utils';

export default function SettingsMain() {
  const dispatch = useAppDispatch();
  const settingsVPO = useAppSelector(getSettingsVPO);

  const currentUser = useAppSelector(selectCurrentUser);

  useEffect(() => {
    dispatch(fetchSettingsRequest());
  }, [dispatch]);

  if (!settingsVPO?.length) {
    return <Loading />;
  }

  const userGroupIds = currentUser.groups.map((g: { Id: number }) => g.Id);
  const filteredSettings = settingsVPO.filter((setting: any) => (setting.UsersGroup ? setting.UsersGroup.some((obj: any) => userGroupIds.includes(obj.id)) : false));

  const displaySettings = filteredSettings.length > 0 ? filteredSettings : settingsVPO;

  return (
    <div>
      <div className='px-7.5 py-[26px] border-b border-[#DFE4EA]-500'>
        <div className='flex items-center gap-2 hover:cursor-pointer w-fit'>
          <span>
            <MobileConfigureIcon />
          </span>
          <span>Настройки</span>
        </div>
      </div>
      <div className='p-7.5'>
        <div className='p-7.5 pt-5 bg-white rounded-md shadow-custom'>
          <h3 className='mb-7.5 font-medium text-black'>Оценка VPO колонн</h3>
          <FlexCol className='gap-[10px]'>
            {displaySettings.map(({ id, title, description, url, icon }) => (
              <a className='flex px-5 py-[18px] gap-3 items-start rounded-lg border border-gray-300 bg-white' target='_blank' href={url} key={id} title={description} rel='noreferrer'>
                <img src={resolveResourceUrl(icon?.[0]?.url, BACKEND_URL)} alt='settingIcon' />
                {title}
              </a>
            ))}
          </FlexCol>
        </div>
      </div>
    </div>
  );
}
